import request from "helpers/api_helper";
import { toast } from "react-toastify";

// Get all users
export const getUsers = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `users${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch users");
    return error;
  }
};

// Get single user
export const getUser = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `users/${id}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch user");
    return error;
  }
};

// Create new user
export const createUser = async (data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "users",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "User created successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to create user");
    return error;
  }
};

// Update user
export const updateUser = async (id: string, data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `users/${id}`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "User updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update user");
    return error;
  }
};

// Delete user
export const deleteUser = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `users/${id}`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "User deleted successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to delete user");
    return error;
  }
};